import classes from '../ccf-call-conference.module.scss';
import { Box, Typography, IconButton, Grow } from '@mui/material';
import {
  CcfParticipantOnHold,
  CcfTypography,
  CcfButton,
  CcfCallMergeIcon,
} from '@nice-ccf/ui-controls';
import { User } from '../ccf-call-conference.slice';
import React from 'react';

interface userProps {
  user: User;
  dispatchSwitchUserAction: () => void;
  dispatchAddUserToConference: () => void;
  showActionButton: boolean;
  animate: boolean;
}

/**
 * Component to be used to show user in Lobby
 * @param props - userProps
 * @example - <UserInLobby />
 * @returns
 */
export const UserInLobby = (props: userProps) => {
  const {
    user,
    dispatchSwitchUserAction,
    dispatchAddUserToConference,
    showActionButton,
    animate,
  } = props;

  const [hover, updateHover] = React.useState(false);
  /**
   * Function for hover effect on mouse enter
   * @example - onMouseEnter()
   * @returns
   */
  const onMouseEnter = () => updateHover(true);
  /**
   * Function for hover effect on mouse leave
   * @example - onMouseLeave()
   * @returns
   */
  const onMouseLeave = () => updateHover(false);

  return (
    <div>
      {user && (
        <Grow in={animate}>
          <Box
            px={1}
            onClick={(e) => {
              e.stopPropagation();
              dispatchSwitchUserAction();
            }}
          >
            <Box display="flex" alignItems="center">
              <CcfTypography
                variant="caption"
                translationKey="waitingOnHoldX"
                extraArgs={{ format: [1] }}
              />
            </Box>
            <Box
              display="flex"
              minHeight={56}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              bgcolor={hover ? 'background.default' : 'background.paper'}
              className={classes.callControlHover}
              alignItems="center"
            >
              <IconButton size="small">
                <CcfParticipantOnHold
                  viewBox="0 0 28 28"
                  htmlColor="grey"
                  classes={{ root: classes.holdIcon }}
                />
              </IconButton>
              <Box pl={0.5} flex="1" maxWidth={hover ? '75%' : '100%'}>
                <Typography
                  variant="subtitle2"
                  noWrap
                  classes={{ root: classes.contentBoldText }}
                >
                  {user.name}
                </Typography>
                <Typography component="div" noWrap variant="caption">
                  {user.designation}
                </Typography>
              </Box>
              {!showActionButton && (
                <CcfButton
                  color="secondary"
                  variant="outlined"
                  classes={{ root: classes.actionButton }}
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatchAddUserToConference();
                  }}
                  size="small"
                >
                  <CcfCallMergeIcon></CcfCallMergeIcon>
                </CcfButton>
              )}
            </Box>
          </Box>
        </Grow>
      )}
    </div>
  );
};
